import { render, staticRenderFns } from "./OP_ByHCCPrintable.vue?vue&type=template&id=3c8c8706&scoped=true&"
import script from "./OP_ByHCCPrintable.vue?vue&type=script&lang=js&"
export * from "./OP_ByHCCPrintable.vue?vue&type=script&lang=js&"
import style0 from "./OP_ByHCCPrintable.vue?vue&type=style&index=0&id=3c8c8706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8c8706",
  null
  
)

export default component.exports